// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"SearchResults_searchResults__3Hwpt","searchQuery":"SearchResults_searchQuery__3q7LG","searchLinks":"SearchResults_searchLinks__1Vcj1"};